// import React from "react";
// import { RouterProvider, createBrowserRouter } from "react-router-dom";

// import { Home } from "./Screens/Home";
// import { Company } from "./Screens/Company";
// import { Pricing } from "./Screens/Pricing";
// import PreviewVideo from "./Screens/PreviewVideo";
// import { Product } from "./Screens/Product";
// import { WizardApp } from "./Screens/WizardApp";
// import { Elauro } from "./Screens/Elauro";
// import { Football } from "./Screens/Football";
// import { Legal } from "./Screens/Legal";
// import { SelectRegister } from "./Components/Register/SelectRegister";
// import { Register } from "./Components/Register/Register";
// import Contact from "./Screens/Contact";
// import { RegisterPlayer } from "./Components/Register/RegisterPlayer";

// const router = createBrowserRouter([
//   { path: "/", element: <Home /> },
//   { path: "/password", element: <Elauro /> },
//   { path: "/register/:type", element: <Register /> },
//   { path: "/register/player", element: <RegisterPlayer /> },
//   { path: "/register-selection", element: <SelectRegister /> },
//   { path: "/company", element: <Company /> },
//   { path: "/pricing", element: <Pricing /> },
//   { path: "/preview/video", element: <PreviewVideo /> },
//   { path: "/product", element: <Product /> },
//   { path: "/app", element: <WizardApp /> },
//   { path: "/football", element: <Football /> },
//   { path: "/legal", element: <Legal /> },
//   { path: "/contact", element: <Contact /> },
// ]);

// export default function Router() {
//   return <RouterProvider router={router} />;
// }
import React from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";

import { Home } from "./Screens/Home";
import { Company } from "./Screens/Company";
import { Pricing } from "./Screens/Pricing";
import PreviewVideo from "./Screens/PreviewVideo";
import { Product } from "./Screens/Product";
import { WizardApp } from "./Screens/WizardApp";
import { Elauro } from "./Screens/Elauro";
import { Football } from "./Screens/Football";
import { Legal } from "./Screens/Legal";
import { SelectRegister } from "./Components/Register/SelectRegister";
import { Register } from "./Components/Register/Register";
import Contact from "./Screens/Contact";
import { RegisterPlayer } from "./Components/Register/RegisterPlayer";
import ProtectedRoute from "./Components/ProtectedRoute/ProtectedRoute";
import PasswordScreen from "./Screens/PasswordScreen";
import Checkout from "./Components/Checkout/Checkout";
import PurchaseSuccess from "./Components/Checkout/PurchaseSuccess";
import PurchaseCancel from "./Components/Checkout/PurchaseCancel";
import { LaunchNew } from "./Screens/LaunchNew";

const router = createBrowserRouter([
  {
    path: "/password",
    element: <PasswordScreen />,
  },
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <Home />
      </ProtectedRoute>
    ),
  },
  {
    path: "/register/:type",
    element: (
      <ProtectedRoute>
        <Register />
      </ProtectedRoute>
    ),
  },
  {
    path: "/register/player",
    element: (
      <ProtectedRoute>
        <RegisterPlayer />
      </ProtectedRoute>
    ),
  },
  {
    path: "/register-selection",
    element: (
      <ProtectedRoute>
        <SelectRegister />
      </ProtectedRoute>
    ),
  },
  {
    path: "/company",
    element: (
      <ProtectedRoute>
        <Company />
      </ProtectedRoute>
    ),
  },
  {
    path: "/pricing",
    element: (
      <ProtectedRoute>
        <Pricing />
      </ProtectedRoute>
    ),
  },
  {
    path: "/preview/video",
    element: (
      <ProtectedRoute>
        <PreviewVideo />
      </ProtectedRoute>
    ),
  },
  {
    path: "/product",
    element: (
      <ProtectedRoute>
        <Product />
      </ProtectedRoute>
    ),
  },
  {
    path: "/app",
    element: (
      <ProtectedRoute>
        <WizardApp />
      </ProtectedRoute>
    ),
  },
  {
    path: "/football",
    element: (
      <ProtectedRoute>
        <Football />
      </ProtectedRoute>
    ),
  },
  {
    path: "/legal",
    element: (
      <ProtectedRoute>
        <Legal />
      </ProtectedRoute>
    ),
  },
  // {
  //   path: "/contact",
  //   element: (
  //     <ProtectedRoute>
  //       <Contact />
  //     </ProtectedRoute>
  //   ),
  // },
  {
    path: "/checkout",
    element: (
      <ProtectedRoute>
        <Checkout />
      </ProtectedRoute>
    ),
  },
  {
    path: "/payment-success",
    element: (
      <ProtectedRoute>
        <PurchaseSuccess />
      </ProtectedRoute>
    ),
  },
  {
    path: "/payment-cancel",
    element: (
      <ProtectedRoute>
        <PurchaseCancel />
      </ProtectedRoute>
    ),
  },
  {
    path: "/launch-new",
    element: (
      <ProtectedRoute>
        <LaunchNew />
      </ProtectedRoute>
    ),
  },
]);

export default function Router() {
  return <RouterProvider router={router} />;
}
